import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 lg:pt-0 lg:pb-0 overflow-hidden bg-navy-900 border-b border-steel-800" data-id="element-81">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full" data-id="element-82">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-83">
          <div className="order-2 lg:order-1 max-w-2xl" data-id="element-84">
            <FadeIn data-id="element-85">
              <div className="inline-block px-3 py-1 mb-6 border border-steel-500 text-amber-500 text-xs font-semibold tracking-widest uppercase rounded-sm" data-id="element-86">
                Intervención Inmediata
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-87">
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-tight mb-6" data-id="element-88">
                DEJA DE <br data-id="element-89" />
                <span className="text-amber-500 italic" data-id="element-90">SOBREPENSAR.</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-91">
              <p className="text-xl sm:text-2xl text-white font-serif mb-6 leading-snug" data-id="element-92">
                El protocolo mecánico para silenciar tu mente en 4 minutos.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-93">
              <p className="text-lg text-offwhite/80 leading-relaxed mb-10 max-w-xl" data-id="element-94">
                Tu mente se ha convertido en un lugar agotador. No es el trabajo
                lo que te tiene drenado. Es el ruido. Es esa conversación que
                repasas por décima vez en tu cabeza.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-95">
              <button onClick={() => document.getElementById('pricing-box')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })} className="bg-amber-500 hover:bg-amber-400 text-navy-900 font-bold text-lg px-8 py-4 rounded-sm transition-colors duration-300 w-full sm:w-auto text-center" data-id="element-96">
                RECUPERAR MI PAZ MENTAL
              </button>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-97">
            <FadeIn delay={0.2} data-id="element-98">
              <div className="relative aspect-[4/5] lg:aspect-square max-w-md mx-auto lg:max-w-none" data-id="element-99">
                <div className="absolute inset-0 bg-gradient-to-tr from-navy-900/80 via-transparent to-transparent z-10" data-id="element-100"></div>
                <img src="https://cdn.magicpatterns.com/uploads/gqcQazDx7Rmfb6W243EGWQ/heylloyd-image-1776408329956.png" alt="Mujer estresada frente a una tablet con el protocolo Deja de Sobrepensar" className="w-full h-full object-cover rounded-sm shadow-2xl border border-steel-800" data-id="element-101" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}